/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import {
  MidasEffectError,
  IOverviewStatisticsWasteByPerson,
  IOverviewStatisticsNumberOfWaste,
  IOverviewStatisticsWasteByDrug,
  OverviewStatisticsNumberOfWitness,
  IOverviewStatisticsNumberOfWasteByHospital,
  IOverviewStatisticsNumberOfWitnessByHospital,
  IOverviewStatisticsRxInterceptWaste,
  IOverviewStatisticsNumberOfStandardWaste, 
  IOverviewStadisticsStandardWasteLocation,
  IOverviewStatisticsRxInterceptWasteByDateRange
} from '@midas/shared/common';
import { createAction, props } from '@ngrx/store';

export const queryWasteByPerson = createAction(
  '[Overview/Statistics] Query Waste by person',
  props<{ startDate: string, endDate: string}>(),
  );
export const queryWasteByPersonSuccess = createAction(
  '[Overview/Statistics] Query waste by person Success',
  props<{ count: number, waste: IOverviewStatisticsWasteByPerson[] }>(),
);
export const queryWasteByPersonError = createAction(
  '[Overview/Statistics] Query waste by person Error',
  props<MidasEffectError>(),
);


export const queryNumberOfWaste = createAction('[Overview/Statistics] Query number of waste', props<{ startDate: string, endDate: string}>(),);
export const queryNumberOfWasteSuccess = createAction(
  '[Overview/Statistics] Query number of waste Success',
  props<{ data: IOverviewStatisticsNumberOfWaste }>(),
);
export const queryNumberOfWasteError = createAction(
  '[Overview/Statistics] Query number of waste Error',
  props<MidasEffectError>(),
);


export const queryWasteByDrug = createAction('[Overview/Statistics] Query Waste by drug', props<{ startDate: string, endDate: string}>(),);
export const queryWasteByDrugSuccess = createAction(
  '[Overview/Statistics] Query waste by drug Success',
  props<{ count: number, waste: IOverviewStatisticsWasteByDrug[] }>(),
);
export const queryWasteByDrugError = createAction(
  '[Overview/Statistics] Query waste by drug Error',
  props<MidasEffectError>(),
);


export const queryNumberOfWitness = createAction('[Overview/Statistics] Query number of witness', props<{ startDate: string, endDate: string}>(),);
export const queryNumberOfWitnessSuccess = createAction(
  '[Overview/Statistics] Query number of witness Success',
  props<{ data: OverviewStatisticsNumberOfWitness }>(),
);
export const queryNumberOfWitnessError = createAction(
  '[Overview/Statistics] Query number of witness Error',
  props<MidasEffectError>(),
);


export const queryNumberOfWasteByHospital = createAction('[Overview/Statistics] Query number of waste by hospital', props<{ startDate: string, endDate: string}>(),);
export const queryNumberOfWasteByHopitalSuccess = createAction(
  '[Overview/Statistics] Query number of waste by hospital Success',
  props<{ count: number, items: IOverviewStatisticsNumberOfWasteByHospital[] }>(),
);
export const queryNumberOfWasteByHospitalError = createAction(
  '[Overview/Statistics] Query number of waste by hospital Error',
  props<MidasEffectError>(),
);


export const queryNumberOfWitnessByHospital = createAction('[Overview/Statistics] Query number of witness by hospital', props<{ startDate: string, endDate: string}>(),);
export const queryNumberOfWitnessByHospitalSuccess = createAction(
  '[Overview/Statistics] Query number of witness by hospital Success',
  props<{ count: number, items: IOverviewStatisticsNumberOfWitnessByHospital[] }>(),
);
export const queryNumberOfWitnessByHospitalError = createAction(
  '[Overview/Statistics] Query number of witness by hospital Error',
  props<MidasEffectError>(),
);

export const queryRxInterceptWaste = createAction('[Overview/Statistics] Query Rx Intercept Waste', props<{ startDate: string, endDate: string}>(),);
export const queryRxInterceptWasteSuccess = createAction(
  '[Overview/Statistics] Query Rx Intercept Waste Success',
  props<{ count: number, items: IOverviewStatisticsRxInterceptWaste[] }>(),
);
export const queryRxInterceptWasteError = createAction(
  '[Overview/Statistics] Query Rx Intercept Waste Error',
  props<MidasEffectError>(),
);


export const queryNumberOfStandardWaste = createAction('[Overview/Statistics] Query number of standard waste', props<{ startDate: string, endDate: string}>(),);
export const queryNumberOfStandardWasteSuccess = createAction(
  '[Overview/Statistics] Query number of standard waste Success',
  props<{ data: IOverviewStatisticsNumberOfStandardWaste }>(),
);
export const queryNumberOfStandardWasteError = createAction(
  '[Overview/Statistics] Query number of standard waste Error',
  props<MidasEffectError>(),
);

export const queryStandardWasteLocation = createAction('[Overview/Statistics] Query standard waste location', props<{ startDate: string, endDate: string}>());
export const queryStandardWasteLocationSuccess = createAction(
  '[Overview/Statistics] Query standard waste location Success',
  props<{ count: number; items: IOverviewStadisticsStandardWasteLocation[] }>(),
);
export const queryStandardWasteLocationError = createAction(
  '[Overview/Statistics] Query standard waste location Error',
  props<MidasEffectError>(),
);



export const queryRxInterceptWasteByDateRange = createAction('[Overview/Statistics] Query Rx Intercept Waste by date range', props<{ startDate: string, endDate: string}>(),);
export const queryRxInterceptWasteByDateRangeSuccess = createAction(
  '[Overview/Statistics] Query Rx Intercept Waste by date range Success',
  props<{ data: IOverviewStatisticsRxInterceptWasteByDateRange }>(),
);
export const queryRxInterceptWasteByDateRangeError = createAction(
  '[Overview/Statistics] Query Rx Intercept Waste by date range Error',
  props<MidasEffectError>(),
);